module.exports = __webpack_public_path__ + "img/airplane.bbc4508e.png";